export default {
      id: "icon--terms-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--terms-usage",
      toString: function () {
        return this.url;
      }
    }